import { Button, Divider, Input, Statistic, Table, Tag, message } from "antd";
import { useEffect, useState } from "react";
import Url from "../../../apiCall/UrlConfig";
///redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../../appRedux/actions/CoreServicesAction";
import { useNavigate } from "react-router-dom";

const ImagePreAddress = Url.baseURL[0] + Url.downloadImage;
const ProfileAnalysisMainPage = (props) => {
  let navigate = useNavigate();
  const [searchTxt, setSearchTxt] = useState("");
  const [_paging, setPaging] = useState({ pageNumber: 1, pageSize: 10 });
  const [_pagingAnalyses, setPagingAnalyses] = useState({
    pageNumber: 1,
    pageSize: 10,
  });

  let ListAnalyses =
    props.coreData[Url.lateral_GetListAnalyses]?.[Url.action]?.data
      ?.listAnalyses;
  let LoadingListAnalyses =
    props.coreData[Url.lateral_GetListAnalyses]?.[Url.action]?.isFetching;
  const Columns = [
    {
      title: "Patien Id",
      dataIndex: "maxilla",
      key: "maxilla",
      render: (obj, item, index) => {
        return <div style={{ textAlign: "center" }}>{item.id}</div>;
      },
    },
    {
      title: "frontal",
      dataIndex: "frontal",
      key: "frontal",
      render: (obj, item, index) => {
        let imageObj = item?.patientImages?.find((o) => o.type == "frontal");
        let imageSource = ImagePreAddress + imageObj?.imageUrl;
        if (imageObj == null) {
          return (
            <img
              key={obj}
              src="/image/dental/notfoundimage.png"
              style={{ width: "70px" }}
            />
          );
        }

        return (
          <>
            <img
              key={obj}
              src={imageSource}
              alt="frontal"
              style={{ width: "70px" }}
            />
            <div></div>
          </>
        );
      },
    },
    // {
    //   title: "lateralphoto",
    //   dataIndex: "lateralphoto",
    //   key: "lateralphoto",
    //   render: (obj, item, index) => {
    //     let imageObj = item?.patientImages?.find(
    //       (o) => o.type == "lateralphoto"
    //     );
    //     let imageSource = ImagePreAddress + imageObj.imageUrl;
    //     return (
    //       <>
    //         <img
    //           key={obj}
    //           src={imageSource}
    //           alt="lateralphoto"
    //           style={{ width: "70px" }}
    //         />
    //         <div></div>
    //       </>
    //     );
    //   },
    // },
    {
      title: "Analyses",
      dataIndex: "maxilla",
      key: "maxilla",
      render: (obj, item, index) => {
        let imageObj = item?.patientImages?.find((o) => o.type == "frontal");
        if (imageObj == null) {
          return <div></div>;
        }
        if (item?.hasFrontalProfileAnalysis) {
          // آنالیزهای ایمپورت‌شده مال کاربر import هستند ولی باید برای همه قابل
          // ویرایش باشند، پس مالک آنالیز فقط رنگ تگ را عوض می‌کند نه دسترسی را.
          let isOwn =
            item?.frontalProfileAnalysis[0]?.userId ==
            props.coreData[Url.getuserIfProfileAnalysis]?.[Url.action]?.data
              ?.userId;

          return (
            <Tag
              color={isOwn ? "cyan" : "#87d068"}
              style={{ cursor: "pointer" }}
              onClick={() => _onClickEditAnalysis(item)}
            >
              {isOwn ? "Edit Your Analysis" : "Edit Analysis"}
            </Tag>
          );
        }
        return <Button onClick={() => _onClickAnalyses(item)}>Analysis</Button>;
      },
    },
  ];

  // const ColumnsAnalyses = [
  //   {
  //     title: "Patient Id",
  //     dataIndex: "PatientID",
  //     key: "PatientId",
  //     render: (object, item) => {
  //       return <div>{item.patientId}</div>;
  //     },
  //   },
  //   {
  //     title: "maxilla",
  //     dataIndex: "maxilla",
  //     key: "maxilla",
  //     render: (obj, item, index) => {
  //       let imageObj = item?.patientImage?.find((o) => o.type == "maxilla");
  //       let imageSource = ImagePreAddress + imageObj.imageUrl;
  //       return (
  //         <>
  //           <img
  //             key={obj}
  //             src={imageSource}
  //             alt="maxilla"
  //             style={{ width: "70px" }}
  //           />
  //           <div></div>
  //         </>
  //       );
  //     },
  //   },
  //   {
  //     title: "lateral cephalometric ",
  //     dataIndex: "lateral cephalometric",
  //     key: "lateral cephalometric",
  //     render: (obj, item, index) => {
  //       let imageObj = item?.patientImage?.find((o) => o.type == "laterall");
  //       let imageSource = ImagePreAddress + imageObj.imageUrl;
  //       return (
  //         <>
  //           <img
  //             key={obj}
  //             src={imageSource}
  //             alt="lateral cephalometric"
  //             style={{ width: "70px" }}
  //           />
  //           <div></div>
  //         </>
  //       );
  //     },
  //   },
  //   // {
  //   //   title: "Analyses",
  //   //   dataIndex: "maxilla",
  //   //   key: "maxilla",
  //   //   render: (obj, item, index) => {
  //   //     return <Button onClick={() => _onClickEditAnalyses(item)}>Edit</Button>;
  //   //   },
  //   // },
  // ];

  const _onClickEditAnalysis = (item) => {
    let imageObj = item?.patientImages?.find((o) => o.type == "frontal");
    let ImageType = imageObj?.imageUrl.split("/")[0];
    let ImageName = imageObj?.imageUrl.split("/")[1];

    navigate(
      `./frontalanalysis/${item.id}/${item?.frontalProfileAnalysis[0]?.id}/${ImageType}/${ImageName}`
    );
  };
  const _getListPatient = async (paging) => {
    let _paging = paging;

    if (paging == null) {
      _paging = {
        pageNumber: 1,
        pageSize: 10,
      };
    }
    let url = Url.profile_GetPatientForProfileAnalysis;

    let res = await props.actions.CallCoreServicesActionWithToken(url, _paging);

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }
  };

  const _getListAnalysis = async () => {
    let url = Url.lateral_GetListAnalyses;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {});

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }
  };

  useEffect(() => {
    // if (!(ListAnalyses?.length > 0)) {
    //   _getListAnalysis();
    // }

    // let pagingAnalyse = JSON.parse(
    //   localStorage.getItem("@lateralCephaloPagingAnalyses")
    // );
    // if (pagingAnalyse == null) {
    //   pagingAnalyse = {
    //     pageNumber: 1,
    //     pageSize: 10,
    //   };
    // }
    // setPagingAnalyses(pagingAnalyse);

    let paging = JSON.parse(localStorage.getItem("@ProfileAnalysisPaging"));
    if (paging == null) {
      paging = {
        pageNumber: 1,
        pageSize: 10,
      };
    }
    setPaging(paging);
    _getListPatient(paging);
  }, []);

  const _onClickAnalyses = (item) => {
    let imageObj = item?.patientImages?.find((o) => o.type == "frontal");
    let ImageType = imageObj?.imageUrl.split("/")[0];
    let ImageName = imageObj?.imageUrl.split("/")[1];
    navigate(`./frontalanalysis/${item.id}/0/${ImageType}/${ImageName}`);
  };

  const _onChangePageSize = (pageNumber, pageSize) => {
    localStorage.setItem(
      "@ProfileAnalysisPaging",
      JSON.stringify({
        pageNumber,
        pageSize,
      })
    );
    setPaging({ pageNumber, pageSize });
    _getListPatient({
      pageNumber,
      pageSize,
    });
  };

  const _onChangePageSizeAnalyses = (pageNumber, pageSize) => {
    localStorage.setItem(
      "@lateralCephaloPagingAnalyses",
      JSON.stringify({
        pageNumber,
        pageSize,
      })
    );
    setPagingAnalyses({ pageNumber, pageSize });
  };

  ListAnalyses = ListAnalyses?.filter((o) => {
    let patinetImage = o.patientImage;
    patinetImage = patinetImage[0];
    let imageUrl = patinetImage.imageUrl;
    let imageName = imageUrl.split("/")[1];
    let finlaimageName =
      imageName.split("_")[0] + "_" + imageName.split("_")[1] + "_";
    return imageName.toLowerCase().includes(searchTxt);
  });

  return (
    <div>
      <div style={{ textAlign: "center" }}>
        update after refresh
        <Statistic
          title="Count of Your Analysis "
          value={
            props.coreData[Url.getuserIfProfileAnalysis]?.[Url.action]?.data
              ?.countAnalysis
          }
        />
      </div>

      {/* <div>
        <Divider>لیست آنالیزهای شما</Divider>
        <div className="flex-row ">
          <Input
            style={{ width: 100, marginLeft: 30 }}
            onChange={(e) => setSearchTxt(e.target.value)}
          />
          <Button>Search</Button>
          {searchTxt}
        </div>
        <Table
          columns={ColumnsAnalyses}
          dataSource={ListAnalyses}
          pagination={{
            current: _pagingAnalyses.pageNumber,
            pageSize: _pagingAnalyses.pageSize,

            onChange: _onChangePageSizeAnalyses,
          }}
          loading={LoadingListAnalyses}
        />
      </div> */}
      <Table
        columns={Columns}
        dataSource={
          props.coreData[Url.profile_GetPatientForProfileAnalysis]?.[Url.action]
            ?.data?.patients
        }
        loading={
          props.coreData[Url.profile_GetPatientForProfileAnalysis]?.[Url.action]
            ?.isFetching
        }
        pagination={{
          current: _paging.pageNumber,
          pageSize: _paging.pageSize,
          total:
            props.coreData[Url.profile_GetPatientForProfileAnalysis]?.[
              Url.action
            ]?.data?.totalCount,
          onChange: _onChangePageSize,
        }}
        rowKey={(o) => o.id}
      />
    </div>
  );
};

const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileAnalysisMainPage);
